import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Spinner } from '@nextui-org/react'
import { FC } from 'react'
import { MdCheck, MdExpandMore, MdStorefront } from 'react-icons/md'
import { useSucursalSso } from './useSucursalSso'

/**
 * Sucursal activa en el header de la sesión federada de WOM.
 *
 * Con una sola sucursal es solo texto (no hay nada que elegir); con varias se vuelve un
 * dropdown para cambiarla sin cerrar sesión: reusa el mismo `resolver` del SucursalGate,
 * así que al elegir otra se reescribe `selectedStore` y los listados recargan filtrados
 * por la tienda nueva.
 */
const SucursalSwitcher: FC = () => {
  const { sucursales, seleccionada, pendiente, resolviendo, error, resolver } = useSucursalSso()

  // Mientras esté pendiente manda el modal del SucursalGate: acá no hay nada que mostrar.
  if (pendiente || seleccionada === '') return null

  if (sucursales.length <= 1) {
    return (
      <span className='header-backoffice-user-store'>
        <MdStorefront /> {seleccionada}
      </span>
    )
  }

  return (
    <Dropdown placement='bottom-end'>
      <DropdownTrigger>
        <button
          type='button'
          className='header-backoffice-user-store header-backoffice-user-store-button'
          title={error !== '' ? error : 'Cambiar sucursal'}
        >
          <MdStorefront />
          <span className='header-backoffice-user-store-name'>{seleccionada}</span>
          {resolviendo ? <Spinner size='sm' /> : <MdExpandMore />}
        </button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label='Cambiar sucursal'
        disabledKeys={resolviendo ? sucursales : []}
        onAction={(key) => {
          const nombre = String(key)
          if (nombre !== seleccionada) resolver(nombre).catch(() => undefined)
        }}
      >
        {sucursales.map((sucursal) => (
          <DropdownItem
            key={sucursal}
            textValue={sucursal}
            startContent={<MdStorefront className='flex-shrink-0 text-gray-400' />}
            endContent={sucursal === seleccionada ? <MdCheck className='text-primary' /> : null}
          >
            {sucursal}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

export default SucursalSwitcher
